// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = () => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let totalSupply = await store
        .getState()
        .blockchain.smartContract.methods.totalSupply()
        .call();
      let mintable = await store
        .getState()
        .blockchain.smartContract.methods.mintable()
        .call();
      // totalSupply -= 1;
      let isPsEnabled = await store
        .getState()
        .blockchain.smartContract.methods.isPublicMPSaleEnabled()
        .call();
      let isWlEnabled = await store
        .getState()
        .blockchain.smartContract.methods.isWlSaleEnabled()
        .call();
      let deployer = await store
        .getState()
        .blockchain.smartContract.methods.deployer()
        .call();

      // let cost = await store
      //   .getState()
      //   .blockchain.smartContract.methods.cost()
      //   .call();

      dispatch(
        fetchDataSuccess({
          totalSupply,
          mintable,
          isPsEnabled,
          deployer,
          isWlEnabled,
          // cost,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
